<div class="col-lg-12">
    <dx-chart id="chartAttLog"   [dataSource]="attlogChart" title="Récords del mes">
        <dxi-series valueField="count"  argumentField="dateTimeString"  name="récords"></dxi-series>
        <dxo-common-series-settings argumentField="state" type="spline" hoverMode="includePoints" name="records">
            <dxo-point hoverMode="allArgumentPoints"></dxo-point>
        </dxo-common-series-settings>
        <dxo-argument-axis>
            <dxo-label verticalAlignment="bottom" horizontalAlignment="center" hoverMode="excludePoints"></dxo-label>
        </dxo-argument-axis>
        <dxo-export [enabled]="true"></dxo-export>
    </dx-chart>
</div>